import { useRef } from "react";
import { Button, Form, Input } from "antd";
import { EducacionNoFormal } from "../../../../models/JuradosModel/jurados.model";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { openNotification } from "../../../../utils/Notifactions";
import DocumentInput from "../../../../utils/DocumentInput";
import DateInput from "../../../../utils/DateInput";
import moment from "moment";

type FormNoFormalProps = {
  educacionNoFormal: EducacionNoFormal;
  guardarFormulario: any;
  setEducacionNoFormal: Function;
  guardarArchivo: any;
  formRef: any;
  resetForm: any;
};

export const FormNoFormal = ({
  educacionNoFormal,
  guardarFormulario,
  setEducacionNoFormal,
  guardarArchivo,
  formRef,
  resetForm,
}: FormNoFormalProps) => {
  const fileInputRef = useRef<any>();

  const fields = [
    { name: "nombre_educacion", value: educacionNoFormal.nombre_educacion },
    { name: "nombre_proceso", value: educacionNoFormal.nombre_proceso },
    { name: "duracion", value: educacionNoFormal.duracion },
    { name: "institucion", value: educacionNoFormal.institucion },
    { name: "fecha_inicio", value: educacionNoFormal.fecha_inicio },
    { name: "fecha_terminacion", value: educacionNoFormal.fecha_terminacion },
    { name: "numero_horas", value: educacionNoFormal.numero_horas },
    { name: "ciudad", value: educacionNoFormal.ciudad },
    { name: "path_anexo", value: educacionNoFormal.path_anexo },
  ];

  return (
    <>
      <Form
        ref={formRef}
        name="educacionNoFormal"
        size="large"
        fields={fields}
        onFinish={(values: any) => {
          if (values.path_anexo === "" || values.path_anexo === undefined) {
            return openNotification({
              titulo: "Error",
              descripcion: "Falta adjuntar archivo",
              placement: "bottomRight",
            });
          }
          if(moment(values.fecha_inicio).isAfter(moment(new Date()).format("YYYY-MM-DD")) || moment(values.fecha_terminacion).isAfter(moment(new Date()).format("YYYY-MM-DD")) ){
            return openNotification({
              titulo: "Error",
              descripcion: "Las fechas no pueden ser iguales o mayores a la fecha actual",
              placement: "bottomRight",
            });
          }
          if(moment(values.fecha_inicio).isAfter(moment(values.fecha_terminacion))){
            return openNotification({
              titulo: "Error",
              descripcion: "La fecha terminación debe ser mayor que la de inicio",
              placement: "bottomRight",
            });
          }
          return guardarFormulario(values);
        }}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...educacionNoFormal };
          for (var i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setEducacionNoFormal(infoupdate);
        }}
        initialValues={educacionNoFormal}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Nombre de educación no formal
            </span>
            <Form.Item
              className="no-margin"
              name="nombre_educacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Nombre del proceso
            </span>
            <Form.Item
              className="no-margin"
              name="nombre_proceso"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Duración -{" "}
              <span className="font-family-Montserrat-Regular font-size-10px">
                &nbsp;semanas
              </span>
            </span>
            <Form.Item
              className="no-margin"
              name="duracion"
              rules={[
                { required: true, message: "Campo obligatorio" },
                { max: 3, message: "Máximo 3 dígitos" },
              ]}
            >
              <Input type="number" min="1" />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Institución -{" "}
              <span className="font-family-Montserrat-Regular font-size-10px">
                &nbsp;opcional
              </span>
            </span>
            <Form.Item className="no-margin" name="institucion">
              <Input maxLength={80} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Ciudad
            </span>
            <Form.Item
              className="no-margin"
              name="ciudad"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <InputTexto
                name="ciudad"
                texto={educacionNoFormal.ciudad}
                setTexto={setEducacionNoFormal}
                alltexto={educacionNoFormal}
                maxLength={50}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Fecha de inicio
            </span>
            <Form.Item
              className="no-margin"
              name="fecha_inicio"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  setEducacionNoFormal({
                    ...educacionNoFormal,
                    fecha_inicio: fecha,
                  });
                }}
                dia={educacionNoFormal.fecha_inicio?.split("-")[2] || ""}
                mes={educacionNoFormal.fecha_inicio?.split("-")[1] || ""}
                anio={educacionNoFormal.fecha_inicio?.split("-")[0] || ""}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Fecha terminación
            </span>
            <Form.Item
              className="no-margin"
              name="fecha_terminacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  setEducacionNoFormal({
                    ...educacionNoFormal,
                    fecha_terminacion: fecha,
                  });
                }}
                dia={educacionNoFormal.fecha_terminacion?.split("-")[2] || ""}
                mes={educacionNoFormal.fecha_terminacion?.split("-")[1] || ""}
                anio={educacionNoFormal.fecha_terminacion?.split("-")[0] || ""}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-2 col-xxl-2 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Número de horas
            </span>
            <Form.Item
              className="no-margin"
              name="numero_horas"
              rules={[
                { required: true, message: "Campo obligatorio" },
                { max: 3, message: "Máximo 3 dígitos" },
              ]}
            >
              <Input type="number" min="1" />
            </Form.Item>
          </div>

          <div className="col-12 col-md-6 col-lg-4 col-xxl-4 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Diploma o certificado
            </span>
            <Form.Item
              className="no-margin"
              name="path_anexo"
              rules={[{ required: true, message: "Documento obligatorio" }]}
            >
              <DocumentInput
                doc={educacionNoFormal.path_anexo}
                fileInputRef={fileInputRef}
                ancho_btn={30}
                on_change={(e) => {
                  guardarArchivo(e);
                  e.target.value = "";
                }}
                onDelete={() => {
                  setEducacionNoFormal({
                    ...educacionNoFormal,
                    path_anexo: "",
                  });
                }}
              />
            </Form.Item>
          </div>
        </div>
        <div className="d-flex justify-content-end align-content-center">
          <div className="d-flex justify-content-end  align-content-center">
            <Button
              className="button-azul-ghost"
              style={{ marginTop: "20px" }}
              onClick={resetForm}
            >
              Limpiar Campos
            </Button>
          </div>
          <div className="d-flex justify-content-end  align-content-center">
            <Button
              className="button-blanco-radius"
              form="educacionNoFormal"
              htmlType="submit"
            >
              Agregar
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};
